<template>
  <Card id="service-card">
    <template v-slot:content>
      <div class="grid-container">
        <div class="id">
          <span class="service-card-field">
            <p>
              <strong style="font-size: 1.3em"> # {{ service.id }}</strong>
            </p>
          </span>
        </div>
        <div class="type">
          <span class="service-card-field">
            <p>
              <ServiceType
                :value="(service.customerService || service)?.type?.path"
                :background="(service.customerService || service)?.type?.color"
              ></ServiceType>
            </p>
          </span>
        </div>
        <div class="bovine-count">
          <span class="sale-card-field">
            <span class="p-mr-2 p-pt-1"><IconBovine /></span>
            <span v-if="service.bovineCount > 1"
              >{{ service.bovineCount }} Bovinos</span
            >
            <span v-else-if="service.bovineCount"
              >{{ service.bovineCount }} Bovino</span
            >
            <span v-else>-</span>
          </span>
        </div>
        <div class="description">
          <span class="service-card-field">
            <span class="material-icons">subject</span>
            <p>
              {{ service.description || '-' }}
            </p>
          </span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import ServiceType from './ServiceType.vue';
import IconBovine from '../../../components/icon/IconBovine.vue';

export default {
  name: 'SaleCard',
  components: {
    ServiceType,
    IconBovine,
  },
  props: {
    service: Object,
  },
};
</script>

<style scoped>
#service-card >>> .p-card-content {
  padding: 0 !important;
}
.service-card-field span {
  padding-right: 10px;
}
.service-card-field p {
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 0.5em 1em;
  grid-template-areas:
    '.'
    '.'
    '.'
    '.';
}

@media (min-width: 600px) {
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0.5em 1em;
    grid-template-areas:
      '. .'
      '. .';
  }
}

@media (min-width: 960px) {
  .grid-container {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: 1fr;
    gap: 0.5em 1em;
    grid-template-areas: '. . . .';
  }
}
</style>
